import { ActionTypes } from '../actions/types';
import { Message } from '../../api';

const initialState = {
  messageList: [] as Message[],
  newNotification: false,
  activeComponent: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.ADD_NOTIFICATIONS:
      return {
        ...state,
        messageList: [...payload],
        newNotification: true,
      };
    case ActionTypes.ADD_NOTIFICATION:
      return {
        ...state,
        messageList: [...state.messageList, payload],
        newNotification: true,
      };
    case ActionTypes.REMOVE_NOTIFICATIONS:
      return {
        ...state,
        messageList: [],
        newNotification: false,
      };
    case ActionTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        messageList: state.messageList.filter(msg => payload.id !== msg.id),
        newNotification: false,
      };
    case ActionTypes.SET_NOTIFICATION_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      return {
        ...state,
        [fieldName]: value,
      };
    }
    default:
      return state;
  }
}
